export const formatDateISO = (dateStr: string): string => {
    if (!dateStr) return '';
    const [year, month, day] = dateStr.split('-');
    return `${day}/${month}/${year}`;
};

export const formatDisbursements = (disbursement: any) => {
    return disbursement?.disbursements?.map((d: any) => ({
        date: formatDateISO(d.date),
        amount: d.amount
    })) || [];
};

export const formatInstallments = (installment: any) => {
    return installment?.items?.map((inst: any, index: number) => ({
        number: index + 1,
        value: inst.value || 0,
        dueDate: formatDateISO(inst.dueDate),
        format: inst.format || 'VALOR',
        document_id: inst.document_id || '',
        document_title: inst.document_title || '',
        receivable_installment: inst.receivable_installment || '',
    })) || [];
};

export const formatFees = (fees: any) => {
    return fees?.items?.map((fee: any) => ({
        name: fee.description || fee.name || '',
        rate: fee.rate || 0,
        amount: fee.value || 0,
        form: fee.form || '',
        interest_period: fee.interest_period || ''
    })) || [];
};

export const getCurrentDate = (): string => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, '0');
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const year = today.getFullYear();
    return `${day}/${month}/${year}`;
};

export const formatHarvestYear = (value: string): string => {
    const numbers = value.replace(/\D/g, '');
    if (numbers.length <= 2) return numbers;
    return `${numbers.slice(0, 2)}/${numbers.slice(2, 4)}`;
};

export const formatISOToDate = (isoDate: string): string => {
    if (!isoDate) return getCurrentDate();
    const dateOnly = isoDate.split('T')[0];
    const [year, month, day] = dateOnly.split('-');
    return `${day}/${month}/${year}`;
};
